export const ARRAY_URL_DELIMITER = '-,-'